import { GET_ASSETS_TYPES, SET_ORDER_ASSET, DELETE_ASSET_ERROR } from '../actions/actionTypes';

function assets (state={}, action) {
    const { type, payload } = action;
    switch(type) {
        case GET_ASSETS_TYPES:
            state = { ...state, assetsType: payload};
            return state;
        case SET_ORDER_ASSET:
            state = { ...state, orderAssets: payload}
            return state;
        case DELETE_ASSET_ERROR:
            state = { ...state, deleteAssetError: payload.error}
            return state;
        default:
            return state;
    }
}

export default assets;
